import { render } from "./PinDeleteModal.vue?vue&type=template&id=dbcf796a&scoped=true"
import script from "./PinDeleteModal.vue?vue&type=script&lang=js"
export * from "./PinDeleteModal.vue?vue&type=script&lang=js"

import "./PinDeleteModal.vue?vue&type=style&index=0&id=dbcf796a&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-dbcf796a"

export default script